// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_1Jzis","price":"F4UqC"};